import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  Text,
  Button,
  VStack,
  Icon
} from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';
import confetti from 'canvas-confetti';
import { useNavigate } from "react-router";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider";

export const PaymentSuccess = ({ onContinue }) => {

  const [secondsLeft, setSecondsLeft] = useState(3)
  const { addBreadcrumb } = useBreadcrumbs()
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const duration = 2 * 1000;
      const end = Date.now() + duration;

      (function frame() {
        const screenWidth = window.innerWidth;

        const leftX = 245 / screenWidth; // 245px from left

        // Left-side confetti shooting toward center
        confetti({
          particleCount: 5,
          angle: 60, // upward & rightward
          spread: 45,
          origin: { x: leftX, y: 1 },
        });

        // Right-side confetti shooting toward center
        confetti({
          particleCount: 5,
          angle: 120, // upward & leftward
          spread: 45,
          origin: { x: 1, y: 1 },
        });

        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    }, 500); // Delay by 0.5s

    // Countdown timer
    const countdownInterval = setInterval(() => {
      setSecondsLeft(prev => prev - 1);
    }, 1000);

    // Redirect after timeout
    const setTimeOut = setTimeout(() => {
      addBreadcrumb("Credits Info", '/credits-info', true)
      navigate('/credits-info');
    }, secondsLeft * 1000);

    // Cleanup
    return () => {
      clearTimeout(timeout);
      clearTimeout(setTimeOut);
      clearInterval(countdownInterval);
    };
  }, []);

  return (
    <Box
      minH="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      px={4}
    >
      <VStack
        bg="white"
        p={10}
        rounded="2xl"
        shadow="xl"
        spacing={6}
        textAlign="center"
      >
        <Icon as={CheckCircleIcon} boxSize={16} color="green.400" />
        <Heading size="lg">Payment Successful!</Heading>
        <Text fontSize="md" color="gray.600">
          Thank you for your purchase. A confirmation email has been sent.
        </Text>
        <span>Redirecting in {secondsLeft} second{secondsLeft !== 1 ? 's' : ''}...</span>
      </VStack>
    </Box>
  );
};
